import { WithdrawalTypes } from '@sparkplug/lib';

export const CashOutMethod = {
    VISA: WithdrawalTypes[0],
    VISA_INTERNATIONAL: WithdrawalTypes[1],
    AMAZON: WithdrawalTypes[2],
    VENMO: WithdrawalTypes[3],
    ACH: WithdrawalTypes[4],
};
